import { Component, OnInit } from '@angular/core';
import { GridApi } from 'ag-grid-community';
import { Router, ActivatedRoute } from '@angular/router';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { ScreenRepositoryModalComponent } from './screen-repository-modal/screen-repository-modal.component';
import { ConfigureControlsModalComponent } from './configure-controls-modal/configure-controls-modal.component';
import { httpOptions, serviceConstants } from '../../constants/service.constants';
import { Screen, SCREEN_CONTROL, ControlStateSource, dropdownsource, Module, ScreenModel } from 'src/app/models/common';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { CommonService } from 'src/app/services/common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-screen-repository',
  templateUrl: './screen-repository.component.html',
  styleUrls: ['./screen-repository.component.scss']
})
export class ScreenRepositoryComponent implements OnInit {
  collapesedOrNot: boolean;
  userForm: UntypedFormGroup;
  gridApi: GridApi;
  modulelist: Module[] = [];
  columnDefs;
  operations;
  rowData;
  screencontrols: Screen;
  advanceSearch;
  selectedRow;
  tempdropsource: dropdownsource;
  sourceitems: dropdownsource[] = [];
  screencode:string="";
  TempOperations: { name: string; id: string; }[];
  NotIncludeDeleteperations: { name: string; id: string; }[];
  StatusList:any=[];
  isSettings:boolean=false;
  screenID;
  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private summaryService: AdministrationSummaryService,
    private commonService: CommonService,
    private modalService: NgbModal
  ) {
    this.screencode = route.snapshot.params['code'];
     ;
  }

  ngOnInit() {
    this.StatusList.push({label:"All",value:"101", checked: true});
    this.StatusList.push({label:"Active",value:"1"});
    this.StatusList.push({label:"Inactive",value:"0"});
    this.userForm = new UntypedFormGroup({
      CODE: new UntypedFormControl(""),
      NAME: new UntypedFormControl(""),
      RecordState: new UntypedFormControl("101")
    });

    //this.getModulesList();
    this.getScreenslist();
    // this.criteriaService.getScreenRepositoryCriteria().subscribe(criteria => {
    //   this.columnDefs = criteria.columnDefs;
    //   this.advanceSearch = criteria.advanceSearch;
    //   this.operations = criteria.operations.map(operation => {
    //     return operation && operation.id === 'add' ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    //   });

    //  // this.getScreensControlslist();
    // })
    this.columnDefs = [
      {
        "headerName": "Screen Name",
        "field": "NAME"
      },
      {
        "headerName": "Status",
        "field": "StatusStr"
      }
    ];

    this.TempOperations= [];
    this.NotIncludeDeleteperations=[];
    if (this.screencode == "ist"){
      this.screenID = "208"
    }
    if (this.screencode == "eap"){
      this.screenID = "508"
    }
    if (this.screencode == "grants"){
      this.screenID = "410"
    }
    if (this.commonService.getScreenPermission(this.screenID, "D")) {
      this.isSettings=true;
      this.TempOperations.push({
        "name": "Delete",
        "id": "delete"
      });
    }
    if (this.commonService.getScreenPermission(this.screenID, "E")) {
      this.isSettings=true;
      this.TempOperations.push({
        "name": "Edit",
        "id": "edit"
      });
      this.NotIncludeDeleteperations.push({
        "name": "Edit",
        "id": "edit"
      });
    }
    if (this.commonService.getScreenPermission(this.screenID, "V")) {
      this.isSettings=true;
      this.TempOperations.push({
        "name": "View",
        "id": "view"
      });
      this.NotIncludeDeleteperations.push({
        "name": "View",
        "id": "view"
      });
    }
    if (this.commonService.getScreenPermission(this.screenID, "N")) {
      this.TempOperations.push({
        "name": "Add Screen",
        "id": "add"
      });
      this.NotIncludeDeleteperations.push({
        "name": "Add Screen",
        "id": "add"
      });
    }

      this.operations = this.TempOperations.map(operation => {
        return operation && operation.id === 'add' ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
      });
  }

  SearchClear() {
    this.userForm = new UntypedFormGroup({
      CODE: new UntypedFormControl(""),
      NAME: new UntypedFormControl(""),
      RecordState: new UntypedFormControl("101")
    });
  }

  ViewAll() {
    //this.setSearchSummary(this.userForm.value);
    var NAME = "-1";
    var RecordState = "101";
    this.userForm = new UntypedFormGroup({
      CODE: new UntypedFormControl(""),
      NAME: new UntypedFormControl(""),
      RecordState: new UntypedFormControl("101")
    });
    
    let model = new ScreenModel();
    model.Id = "0";
    model.RecordState = RecordState;
    model.Name = NAME;
    model.ModuleId = this.screencode;

    this.summaryService.getScreenRepositorySummaryAdvance(model).subscribe(summary => {
      this.rowData = this.setOperations(summary);
    });

  }

  AdvanceSearch() {
    //this.setSearchSummary(this.userForm.value);
    var formData = this.userForm.value;
    var NAME = "-1";
    var RecordState = "101";
    if (formData.NAME != null && formData.NAME != "" && formData.NAME != undefined) {
      NAME = formData.NAME;
    }
    if (formData.RecordState != null && formData.RecordState != "" && formData.RecordState != undefined) {
      RecordState = formData.RecordState;
    }

    let model = new ScreenModel();
    model.Id = "0";
    model.RecordState = RecordState;
    model.Name = NAME;
    model.ModuleId = this.screencode;

    this.summaryService.getScreenRepositorySummaryAdvance(model).subscribe(summary => {
      this.rowData = this.setOperations(summary);
    });

  }

  getScreenslist() {
    this.summaryService.getScreenRepositorySummary("0",this.screencode).subscribe(summary => {
      this.rowData = this.setOperations(summary);
    });
  }
  setOperations(rowData:any)
  {
    rowData.forEach(element => {
      if (element.SCREENTYPE != "Static")
     {
        element["Operations"]=this.TempOperations.map(operation => {
          return (operation && (operation.id === 'add' || operation.id==='view_modal'))? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
        });
        this.operations = this.TempOperations.map(operation => {
          return (operation && (operation.id === 'add' || operation.id==='view_modal'))? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
        });
      }
      else{
        element["Operations"]=this.NotIncludeDeleteperations.map(operation => {
          return (operation && (operation.id === 'add' || operation.id==='view_modal'))? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
        });
        this.operations = this.NotIncludeDeleteperations.map(operation => {
          return (operation && (operation.id === 'add' || operation.id==='view_modal'))? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
        });
      }
    });

   return rowData;
  }
  getScreensControlslist() {
    var screenid = "bcebf217-8cac-42b8-9770-540013f1aa01";
    this.summaryService.getScreenControlsList(screenid).subscribe(summary => {
      this.screencontrols = summary;
      if (this.screencontrols != null && this.screencontrols[0].SCREEN_CONTROL.length > 0) {
        for (var i = 0; i < this.screencontrols[0].SCREEN_CONTROL.length; i++) {
          if (this.screencontrols[0].SCREEN_CONTROL[i].CONTROL == "4" || this.screencontrols[0].SCREEN_CONTROL[i].CONTROL == "5" || this.screencontrols[0].SCREEN_CONTROL[i].CONTROL == "6") {
            var optionvalues = this.screencontrols[0].SCREEN_CONTROL[i].GROUP_VALUES;
            var options = optionvalues.split(',');
            if (options.length > 0) {
              this.sourceitems = [];
              for (var iOpt = 0; iOpt < options.length; iOpt++) {
                if (options[iOpt] != null && options[iOpt] != "") {
                  let sourceitems = new dropdownsource();
                  sourceitems.label = options[iOpt];
                  sourceitems.value = options[iOpt];
                  //this.screencontrols[0].SCREEN_CONTROL[i].SourceItems.push(sourceitems);
                  this.sourceitems.push(sourceitems);
                }
              }
              this.screencontrols[0].SCREEN_CONTROL[i].SourceItems = this.sourceitems;
            }
          }
        }
      }
    });
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(event) {

  }

  edit(RecordData: any) {
     ;
    let moduleid="0";
    switch(this['self'].screencode)
    {
      case "ist":
        moduleid="2";
        break;
        case "eap":
          moduleid="5";
        break;
        case "grants":
          moduleid="4";
        break;
    }
    let modalRef = this['self'].modalService.open(ScreenRepositoryModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true,

    });
    modalRef.componentInstance.Content= {
      heading: 'Edit',
      content: { id: RecordData['ID'],ModuleID:moduleid,ModuleName:this['self'].screencode }
    }
    modalRef.result.then(result => {
      this['self'].getScreenslist();
    })
  }
  view(RecordData: any) {
     ;
    let moduleid="0";
    switch(this['self'].screencode)
    {
      case "ist":
        moduleid="2";
        break;
        case "eap":
          moduleid="5";
        break;
        case "grants":
          moduleid="4";
        break;
    }
    let modalRef = this['self'].modalService.open(ScreenRepositoryModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-llg right modal-right',
      animation: true,

    });
    modalRef.componentInstance.Content= {
      heading: 'View',
      content: { id: RecordData['ID'],ModuleID:moduleid,ModuleName:this['self'].screencode }
    }
    modalRef.result.then(result => {
      this['self'].getScreenslist();
    })
  }
  delete(RecordData: any) {
    let moduleid="0";
    switch(this['self'].screencode)
    {
      case "ist":
        moduleid="2";
        break;
        case "eap":
          moduleid="5";
        break;
        case "grants":
          moduleid="4";
        break;
    }
    const modalRef = this["self"].modalService.open(DeleteBoxComponent,{backdrop: false
      })
      modalRef.componentInstance.Content=
      {heading: 'Delete',
      custommessage: 'Are you sure you want to delete the screen ' + "'" +RecordData['NAME']+ "'" +'?',
      ProceedButtonName:"Delete",
      TerminateButtonName:"Cancel"}

      modalRef.result.then(result => {
      if(result=="okclick")
      {
        this['self'].summaryService.deleteScreen(RecordData['ID']).subscribe((result) => {
           if(result.Status==0)
           {
             ;
            this['self'].commonService.SuccessBanner("Screen '"+RecordData['NAME']+"' Deleted successfully");
            this['self'].getScreenslist();

          }
           else{
            this['self'].commonService.ValidationBanner(result.Message);
           }
        })
      }
     });
  }
  add() {
    let moduleid="0";
    switch(this['self'].screencode)
    {
      case "ist":
        moduleid="2";
        break;
        case "eap":
          moduleid="5";
        break;
        case "grants":
          moduleid="4";
        break;
    }
    const modalRef = this['self'].modalService.open(ScreenRepositoryModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true,

    });
    modalRef.componentInstance.Content = {
      heading: 'Add',
      content: {ModuleID:moduleid,ModuleName:this['self'].screencode}
    }
    modalRef.result.then(result => {

      if(result)
      this['self'].getScreenslist();
    })
  }


}
